import { Action } from '@ngrx/store'

import { LoggedVendorUserV1 } from '../../../../api/api/models/logged-vendor-user-v1'
import { UserImage } from '../../../user/user-image'

/**
 * Created by sange on 17/08/2017.
 */

export const ME = '[User] Me'
export const ME_REFRESH = '[User] Me refresh'

export const SAVE_PROFILE = '[User] Save profile'
export const SAVE_PROFILE_SUCCESS = '[User] Save profile success'

export const UPLOAD_IMAGE = '[User] Upload image'
export const UPLOAD_IMAGE_SUCCESS = '[User] Upload image success'

export class Me implements Action {
  readonly type = ME

  constructor(public payload: { user: LoggedVendorUserV1 }) {
  }
}

export class MeRefresh implements Action {
  readonly type = ME_REFRESH
}

export class SaveProfile implements Action {
  readonly type = SAVE_PROFILE

  constructor(public payload: { user: LoggedVendorUserV1 }) {
  }
}

export class SaveProfileSuccess implements Action {
  readonly type = SAVE_PROFILE_SUCCESS

  constructor(public payload: { user: LoggedVendorUserV1 }) {
  }
}

export class UploadImage implements Action {
  readonly type = UPLOAD_IMAGE

  constructor(public payload: UserImage) {
  }
}

export class UploadImageSuccess implements Action {
  readonly type = UPLOAD_IMAGE_SUCCESS

  constructor(public payload: { imgUrl: string }) {
  }
}

export type UserActions =
  SaveProfile
  | SaveProfileSuccess
  | UploadImage
  | UploadImageSuccess
  | Me
  | MeRefresh




// WEBPACK FOOTER //
// ./src/app/shared/auth/store/actions/user.actions.ts